import type { SVGProps } from 'react';

const SvgGiftLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M20.8889 8H3.11111C2.49746 8 2 8.44772 2 9V11C2 11.5523 2.49746 12 3.11111 12H20.8889C21.5025 12 22 11.5523 22 11V9C22 8.44772 21.5025 8 20.8889 8Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M12 8V22' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M20 12V19.7778C20 20.3671 19.7592 20.9324 19.3305 21.3491C18.9019 21.7659 18.3205 22 17.7143 22H6.28571C5.67951 22 5.09812 21.7659 4.66947 21.3491C4.24082 20.9324 4 20.3671 4 19.7778V12'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6.85714 8C6.09938 8 5.37266 7.68396 4.83684 7.1214C4.30102 6.55884 4 5.79584 4 5.00026C4 4.20468 4.30102 3.44169 4.83684 2.87913C5.37266 2.31657 6.09938 2.00052 6.85714 2.00052C7.95964 1.98036 9.04003 2.54199 9.95741 3.61218C10.8748 4.68236 11.5866 6.21144 12 8C12.4134 6.21144 13.1252 4.68236 14.0426 3.61218C14.96 2.54199 16.0404 1.98036 17.1429 2.00052C17.9006 2.00052 18.6273 2.31657 19.1632 2.87913C19.699 3.44169 20 4.20468 20 5.00026C20 5.79584 19.699 6.55884 19.1632 7.1214C18.6273 7.68396 17.9006 8 17.1429 8'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export default SvgGiftLt;
